export const IsEventFromFormInput: (event: Event) => boolean = (event: Event): boolean => {
    const clickedElement: HTMLElement | null = event.target as HTMLElement;
    const isInputElement: boolean = clickedElement ? clickedElement.tagName === 'INPUT' : false;

    return isInputElement;
};
